import React, { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { MainContext } from '../../context';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useStyles } from './styles';

export const GetStartedButton = () => {
  const classes = useStyles();

  return (
    <Link to="/createPlaylist">
      <Button variant="contained" className={classes.nextButton} size="large">
        Get Started!
        <ArrowForwardIcon style={{ color: 'white', marginLeft: 5 }} />
      </Button>
    </Link>
  );
};
